import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

/**
 * After Color or Binding is selected, replace the OptionGallery with
 * a SelectedOptionDisplay, a "roll-up" that describes the user's choice.
 * For color or border/binding attribute, show the user's selection
 * as an image, with a link to discard it.
 *
 * modernized 2023-02
 */
export default function SelectedOptionDisplay({selection, option, callbacks}) {
  if (!selection)
    return null;

  // FIXME snake_case
  const {
    name = "option",  // Carmine Red (410)
    small_image: smallImage, // https://s3.amazonaws.com/configuretech...
    license_image: licenseImage
    // many other attributes not used
  } = selection;

  const handleReset = (e) => {
    console.log("clear option - " + option.name);
    callbacks.selectOption(option.name, null);
  }

  return (
    <div className="user-selection">
      <div className="image-box">
        {smallImage && <img src={smallImage} alt={name}/>}
      </div>
      <div className="description-box">
        <h4>Your selected {option.name}:</h4>
        <h3>
          {name || selection.description}
        </h3>
      </div>
      <div className="change-selection">
        <a className="reset" onClick={handleReset}>
          <i className="fa fa-plus" aria-hidden="true"></i>
          change selection
        </a>
        {licenseImage && <img src={licenseImage} className="license-image" alt={name}/>}
      </div>
    </div>);
}

SelectedOptionDisplay.propTypes = {
  selection: PropTypes.object,
  option: PropTypes.object.isRequired
}
